import styled from 'styled-components';

export const SideBarWrapper = styled.div`
  flex: 1;
  padding: 2rem 1rem;
  max-width: 400px;
  //background-color: pink;

  @media ${(props) => props.theme.breakpoints.tablet} {
    display: none;
  }
`;
